'use client';
import React, { useEffect, useState } from 'react';
import { Button, Div, Skeleton } from '@pezeshk-book/ui-kit';
import { LaboratoryActions } from '@store/lab/lab-actions';
import { useDispatch } from 'react-redux';
import cityItemsApi from '@api/labs/city-items';
import getParseRoute from '@utils/helpers/parse-route';
import routes from '@routes';
import { useRouter } from 'next-nprogress-bar';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import dictionaryParser from '@utils/helpers/dictionary-parser';

const TestInCities = ({ slug, labs, hashedId } : {slug: string, labs: Array<{slug: string, id: string}>, hashedId: string}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { lang } = useParams<{lang: 'en' |'fa'}>();
  const { services: { laboratory: { index: { buttons } } } } = getDictionary(lang);
  const [cityList, setCityList] = useState<Array<{id: string, title: string}>>([]);
  const [loading, setLoading] = useState(true);

  const handleSetServiceType = ({ cityId } : {cityId: string}) => {
    dispatch(LaboratoryActions.setShoppingCartInitialState());
    router.push(getParseRoute({ pathname: routes['route.labs.show'], query: { id: slug, cityId: cityId }, locale: lang }));
  };

  useEffect(() => {
    const lab = labs.find(value => value.slug === slug);
    if (lab?.id) {
      getCityList({ id: lab?.id });
    }
  }, []);

  const getCityList = async ({ id }: {id: string}) => {
    try {
      const cities = await cityItemsApi({ hashedLabId: hashedId, hashedServiceSubTypeId: id });
      setCityList(cities?.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Div className={'mt-1 md:mt-8 mb-20 flex-wrap justify-between md:gap-4 gap-2 md:mb-4'}>
        <Skeleton className={'w-full sm:w-[48.5%] md:w-[23%]'} />
        <Skeleton className={'w-full sm:w-[48.5%] md:w-[23%]'} />
        <Skeleton className={'w-full sm:w-[48.5%] md:w-[23%]'} />
        <Skeleton className={'w-full sm:w-[48.5%] md:w-[23%]'} />
      </Div>
    );
  }

  return (
    <Div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-1 md:mt-8 mb-20 flex-wrap justify-center md:gap-4 gap-2 md:mb-4'}>
      {cityList && cityList.length > 0 && cityList.map((item, index) => (
        <Button key={item.id} className={'text-center w-full'} onClick={() => handleSetServiceType({ cityId: item.id })} variant={'outlined'}>
          {dictionaryParser({ content: buttons.select_city, variables: [{ title: item.title }] })}
        </Button>
      ))}
    </Div>
  );
};

export default TestInCities;
